<div class="h-full flex flex-col"
     *ngrxLet="locationListViewModel$; let model;">
  <app-location-list-action-bar/>

  <div id="view-container">

    <div [id]="gridContainerId" (mouseleave)="onGridMouseLeave()">

      @if (!model.loadingGbpLocationGroups) {
        <ag-grid-angular
            style="width: 100%; height: 100%"
            class="ag-theme-material"
            [defaultColDef]="defaultColumnDefs"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            [rowData]="model.locations"
            [paginationPageSize]="model.pageSize"
            (gridReady)="onGridReady($event, model.columnState, model.selectedRowsIds, model.filterModel)"
            (cellEditRequest)="onCellEditRequest($event)"
            (cellContextMenu)="onCellRightClick($event)"
            (sortChanged)="onSortChanged($event)"
            (rowDataUpdated)="onRowDataUpdated($event)"
            (filterChanged)="onFilterChanged($event)"
            (paginationChanged)="syncPaginationData($event, model.pageSize)"
            (cellDoubleClicked)="onCellDblClicked($event, model.focusedRowId)"
            (selectionChanged)="onSelectionChanged($event)"
            (cellMouseOver)="onCellMouseOver($event, model.hoveredRowId)"
            (cellMouseOut)="onCellMouseOut()"
            (columnVisible)="onColumnVisible($event)"
            (columnPinned)="onColumnPinned($event)"
            (columnMoved)="onColumnMoved($event)"
            (columnResized)="onColumnResized($event)"
            (cellFocused)="onCellFocused($event)"
        ></ag-grid-angular>
      } @else {
        <div class="h-full w-full flex items-center justify-center">
          <mat-spinner/>
        </div>
      }

    </div>

    <!-- Toolbar bottom (containing color bubbles and paginator) -->
    <div id="actionBarBottom"
         #actionBarBottom
         class="actionBar relative">
      <app-status-filter-legend></app-status-filter-legend>

      <div class="scrollable" [ngClass]="{'scroll': actionBarBottom?.offsetWidth <= 990 }">
        <div id="paginatorContainer">
          <mat-paginator #paginator
                         #paginatorElement
                         [selectConfig]="{panelClass: 'paginatorConfig'}"
                         [length]="model.total"
                         [pageIndex]="model.pageIndex"
                         [pageSize]="model.pageSize"
                         [pageSizeOptions]="model.itemsPerPage"
                         (page)="setPaginatorData($event.pageIndex, $event.pageSize)"
                         [showFirstLastButtons]="true">
          </mat-paginator>
        </div>

        <app-jumper prefix="Page:"
                    [currentItemIndex]="model?.pageIndex + 1"
                    [numberOfItems]="paginator.getNumberOfPages()"
                    (currentItemChanged)="setPaginatorData($event - 1, model.pageSize)"/>
    </div>

      <div id="expansionPanelToggles" class="flex h-9 p-1 mr-2">
        <button mat-icon-button
                [disableRipple]="true"
                class="mr-1"
                [ngClass]="{'highlighted': model?.skeletonLayout['bottomPanelActive']}"
                (click)="onToggleBottomPanelClick()">
          <mat-icon svgIcon="toggle_bottom_panel" class="mr-0 w-[24px] h-[24px]"></mat-icon>
        </button>
        <button mat-icon-button
                [disableRipple]="true"
                [ngClass]="{'highlighted': model?.skeletonLayout['rightPanelActive']}"
                (click)="onToggleRightPanelClick()">
          <mat-icon svgIcon="toggle_right_panel" class="mr-0 w-[24px] h-[24px]"></mat-icon>
        </button>
      </div>

    </div>

    <ng-container *ngrxLet="imagePreviewURL$; let url">
      @if (url) {
        <img id="hoverImage" alt="Hovered image preview" [src]="url">
      }
    </ng-container>


    <app-row-menu #rowMenu></app-row-menu>
    <!-- Trigger a context menu, i.e. row action menu. We're able to position the context menu by
    positioning the trigger itself. Added in BLS-2824-->
    <div *ngrxLet="rowMenuPosition$; let menuPosition"
      [matMenuTriggerFor]="rowMenu.rowActionMenu"
      #rowMenuTrigger='matMenuTrigger'
      class="fixed"
      [style.top.px]="menuPosition?.top"
      [style.left.px]="menuPosition?.left"
      (menuClosed)="onRowMenuClosed()"
      (menuOpened)="refocusCell()">
    </div>

  </div>
</div>
